/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPPARTYTYPE = {
    Individual: 'I',
    Trust: 'T',
    Company: 'C',
    NonTaxableInstitute: 'N'
} as const;
export type IAPPARTYTYPE = typeof IAPPARTYTYPE[keyof typeof IAPPARTYTYPE];


export function IAPPARTYTYPEFromJSON(json: any): IAPPARTYTYPE {
    return IAPPARTYTYPEFromJSONTyped(json, false);
}

export function IAPPARTYTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPPARTYTYPE {
    return json as IAPPARTYTYPE;
}

export function IAPPARTYTYPEToJSON(value?: IAPPARTYTYPE | null): any {
    return value as any;
}

